/*
 * A helper function to get the ui config
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { HttpClient } from '@angular/common/http';
import { Constants } from 'app/shared/config/constants';
import { AuthService } from 'app/shared/services/auth.service';
import { UiConfigService } from 'app/shared/services/ui-config.service';
import { Router } from '@angular/router';
import { getUrlSegmentKey, isHandOffApp } from 'app/shared/lib/helper-functions';
import { UiConfig } from 'app/shared/models';

export function initUiConfig (
  http: HttpClient,
  service: UiConfigService,
  authService: AuthService,
  router: Router ) {
  const urlSegmentKey = getUrlSegmentKey ();
  const shouldInvalidateForRequestedContext = location.pathname !== '/authenticate';
  // LoginComponent applies this check itself once it has validated the hand-off request
  const isHandOffLoginRequest = isHandOffApp ( new URLSearchParams ( location.search ).get ( Constants.authRedirectAppParam ) );

  const invalidateAuthIfNeeded = async ( requestedUrlSegmentKey?: string | null ) => {
    if ( shouldInvalidateForRequestedContext ) {
      await authService.invalidateAuthIfUiConfigMismatch ( requestedUrlSegmentKey );
    }
  };

  if ( urlSegmentKey ) {
    return () => {
      return http.get<UiConfig> ( `${ Constants.uiConfigServiceUrl }/${ urlSegmentKey }` )
        .toPromise ()
        .then ( async uiConfig => {
          service.uiConfig = uiConfig;
          await invalidateAuthIfNeeded ( urlSegmentKey );
        } ).catch ( error => {
          console.error ( error );
          router.navigate ( [ '/error/404' ] ).then ();
        } );
    };
  } else {
    if ( location.pathname === '/login' || location.pathname === '/login/' || location.pathname === '/' ) {
      service.uiConfig = {};
    }
    return async () => {
      if ( ( location.pathname === '/login' || location.pathname === '/login/' || location.pathname === '/' ) && !isHandOffLoginRequest ) {
        await invalidateAuthIfNeeded ( null );
      }

      return true;
    };
  }
}
